exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nsvg[data-v-5507cc7c] {\n  width: 22 * 0.05333333333333334rem;\n  height: 22 * 0.05333333333333334rem;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/thomas-zh-88phat-m/src/pages/build800/views/My/Wallet/AddWallet/components/IconEWallet.vue"],"names":[],"mappings":";AACA;EACE,mCAAmC;EACnC,oCAAoC;CACrC","file":"IconEWallet.vue","sourcesContent":["\nsvg[data-v-5507cc7c] {\n  width: 22 * 0.05333333333333334rem;\n  height: 22 * 0.05333333333333334rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5507cc7c","scoped":true,"hasInlineConfig":false}!./build/xpx-to-sbrem-loader.js!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/build800/views/My/Wallet/AddWallet/components/IconEWallet.vue
// module id = /8zx
// module chunks = 0